import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var CurrentUser = require("lib/account/CurrentUser");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var RosterActions = require("lib/actions/RosterActions");

var ButtonDropdown = require("components/utility/ButtonDropdown");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var LoadingButton = require("components/utility/LoadingButton");
var Spinner = require("components/utility/Spinner");

require("users/shared/merge_student_lists_form.scss");

@connect(
  (state, props) => {
    var id = props.effectiveUserID ? props.effectiveUserID : CurrentUser.get().id
    return {
      admin: RosterSelectors.admin({ state, id }),
      studentLists: RosterSelectors.studentLists({ state })
    }
  },
  (dispatch, props) => ({
    populateData: () => {
      var id = props.effectiveUserID ? props.effectiveUserID : CurrentUser.get().id
      var admin = RosterActions.fetchAdmins({ conditions: { userIDs: [id] }, embeds: ['user.link_suggestion', 'admin.related_users'] })
      var studentLists = dispatch(RosterActions.fetchStudentLists({ embeds: ["student_list.admins"] }))

      return Promise.all([studentLists, admin]);
    },
    mergeStudentLists: (params) => {
      return dispatch(RosterActions.postUserTrigger(CurrentUser.get().id, params))
    },
    fetchRosterData: () => {
      var clearStudentLists = dispatch(RosterActions.clearStudentLists({}))
      var rosterRefresh = dispatch(RosterActions.fetchRosterData({}))
      return Promise.all([clearStudentLists, rosterRefresh]);
    },
  })
)

@providePopulateData()
class MergeStudentListsForm extends React.Component {
  constructor(props) {
    super();
    autobind(this);


    this.state = {
      slMapping: [],
      loading: false
    }
  }

  ///////// HELPERS /////////
  formatMappingHash() {
    var remove = _.pluck(_.filter(this.state.slMapping, (map) => { return map.option == REMOVE }), 'student_list_id')
    var keep = _.pluck(_.filter(this.state.slMapping, (map) => { return map.option == KEEP }), 'student_list_id')
    return { keep, remove }
  }

  mergedStudentLists() {
    return _.flatten(_.pluck(this.props.admin.related_users, 'student_list_ids'))
  }

  initMap() {
    var { admin, studentLists } = this.props
    if (admin && studentLists) {
      var mergedStudentLists = _.flatten(_.pluck(admin.related_users, 'student_list_ids'))
      var slMapping = _.map(studentLists, (sl) => {
        var option = _.contains(mergedStudentLists, sl.id) ? REMOVE : KEEP
        return { student_list_id: sl.id, option }
      })

      this.setState({ slMapping })
    }
  }

  //////////////////////////

  //// SUBMIT HANDLER /////
  onSubmit() {
    this.setState({ loading: true })

    var slMapping = this.formatMappingHash()

    // merge student lists
    var params = { what: "merge_student_lists", mapping: slMapping }

    this.props.mergeStudentLists(params).then((response) => {
      this.setState({ loading: false })

      if (response.success) {
        // reload student lists in state (needed since trigger function isn't Reduxy)
        this.props.fetchRosterData().then(() => {
          window.wrNotifications.triggerDropDownNotification({
            title: "Success!", text: "Student lists have been merged with this account", icon: "ok-sign"
          });
          if (this.props.afterSubmit) {
            this.props.afterSubmit()
          }
          this.setState({ loading: false })
        })
      } else {
        this.setState({ loading: false })
        // error message
        window.wrNotifications.triggerDropDownNotification({
          title: "Oops!", text: "Something went wrong and the student lists were not merged",
          type: "error", icon: "exclamation-sign"
        }, 4000);
      }
    })
  }

  dropdownText(slID) {
    var map = _.findWhere(this.state.slMapping, { student_list_id: slID })
    return map ? map.option : ''
  }
  //////////////////////////

  ///// EVENT HANDLERS /////
  handleClick(sl, option) {
    var slMapping = _.filter(this.state.slMapping, (map) => { return map.student_list_id != sl.id })
    slMapping = [...slMapping, { student_list_id: sl.id, option: option }]
    this.setState({ slMapping: slMapping })
  }
  //////////////////////////

  /// RENDER FUNCTIONS ////
  renderOptionDropdown(sl) {
    var dropdownOptions = _.map(OPTIONS, (option) => {
      return <ButtonDropdownOption onClick={() => this.handleClick(sl, option)}
        text={option} key={option} />
    })
    return (
      <div className='slOptionsDropdown'>
        <ButtonDropdown text={this.dropdownText(sl.id)} className="duplicateUserButtonDropdown">
          {dropdownOptions}
        </ButtonDropdown>
      </div>
    )
  }

  renderRows() {
    return _.map(this.props.studentLists, (sl, index) => {
      var borderClass = index == _.size(this.props.studentLists) - 1 ? '' : 'borderBottom'
      return (
        <div className={`slRow ${borderClass}`} key={'sl-' + sl.id}>
          <div className='slColumn'>
            {sl.name}
          </div>
          <div className="slOptionsColumn">
            {this.renderOptionDropdown(sl)}
          </div>
        </div>
      )
    })
  }
  //////////////////////////

  render() {
    if (this.state.loading) {
      return <Spinner placeholder={true} scale={1.7} />
    } else if (!_.isEmpty(this.props.studentLists)) {
      return (
        <div className="mergeStudentListsForm">
          <div className="labelRow">
            <div className="studentListListLabel">Student lists</div>
          </div>
          <div className="slList">
            {this.renderRows()}
            <div className="btnContainer">
              <LoadingButton loading={this.state.loading} text="Submit"
                className="btn buttonPrimary submitLink"
                onClick={() => this.onSubmit()} />
            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  componentDidMount() {
    this.initMap()
  }

  componentDidUpdate(prevProps) {
    if (_.size(prevProps.studentLists) !== _.size(this.props.studentLists)) {
      this.initMap()
    }
  }
}

var KEEP = 'Keep'
var REMOVE = 'Remove'
var OPTIONS = [KEEP, REMOVE];

MergeStudentListsForm.WrappedComponent.propTypes = PageStrictPropTypes({
  studentListIDs: PropTypes.array,
  studentLists: PropTypes.array,
  admin: PropTypes.object,
  effectiveUserID: PropTypes.number,

  populateData: PropTypes.func.isRequired,
  afterSubmit: PropTypes.func,
  mergeStudentLists: PropTypes.func,
  fetchRosterData: PropTypes.func,
})

module.exports = MergeStudentListsForm;


// WEBPACK FOOTER //
// ./modules/components/users/shared/MergeStudentListsForm.js